import { render, staticRenderFns } from "./ProfessionalWorkingHoursForm.vue?vue&type=template&id=db6a3324"
import script from "./ProfessionalWorkingHoursForm.vue?vue&type=script&lang=js"
export * from "./ProfessionalWorkingHoursForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports